<template>
  <div
    id="pageRoot"
    class="backgroundDeaf"
    style="background-color: var(--book-background-color)"
  >
    <span class="normalTheme pageInstruction" style="left: 67px; top: 111px">
      <p>
        Presenta a tus amigos<br />
        subiendo una foto<br />
        y escribiendo sus nombres.
      </p>
    </span>
    <img
      id="zorrito"
      class="pageElement basicItem01"
      src="/pages/img/intro/svgZorrito02.svg"
    />

<uploaded-image
      class="image01 pageElement picture-slot hover-animation-b"
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
    ></uploaded-image>
    <div
      id="button01"
      style="position: absolute; margin-left: 2.5%; margin-top: 66%; z-index: 5"
    >
      <image-upload
        v-bind:page="$parent.page"
        v-bind:type="$parent.type"
        number="1"
      ></image-upload>
    </div>
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField01"
    />

    <uploaded-image
      class="image02 pageElement picture-slot hover-animation-b"
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="2"
    ></uploaded-image>
    <div
      id="button02"
      style="position: absolute; margin-left: 2.5%; margin-top: 66%; z-index: 5"
    >
      <image-upload
        v-bind:page="$parent.page"
        v-bind:type="$parent.type"
        number="2"
      ></image-upload>
    </div>
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="2"
      id="inputField02"
    />
  </div>
</template>
<style scoped>
@import "../../../assets/css/sordoStyle.css";
#zorrito {
  position: absolute;
  left: 12px;
  top: 265px;
}

.image01 {
  position: absolute;
  width: 482px;
  height: 309px;
  left: 523px;
  top: 48px;
}
.image02 {
  position: absolute;
  width: 482px;
  height: 309px;
  left: 523px;
  top: 408px;
}
#button01 {
  width: 216px;
  height: 77px;
  left: 777px;
  top: -360px;
}
#button02 {
  width: 216px;
  height: 77px;
  left: 777px;
  top: 2px;
}
#inputField01 {
  position: absolute;
  width: 226px;
  height: 31px;
  left: 536px;
  top: 325px;
  z-index: 5;
}
#inputField02 {
  position: absolute;
  width: 226px;
  height: 31px;
  left: 536px;
  top: 683px;
  z-index: 5;
}
</style>
<script>
import ImageUpload from "../../../components/ImageUpload.vue";
export default {
  name: "App",
  components: {
    ImageUpload,
  },
};
</script>
